module.exports = __webpack_public_path__ + "img/logo.d063fcb3.svg";